interface CallRealtimeStatistics {
    callQueue?: number;
    callInboundInProgress?: number;
    callOutboundInProgress?: number;
}

interface UserRealtimeStatistics {
    userOnline?: number;
    userOffline?: number;
    averageQuality?: string;
}

export interface RealtimeStatisticsSummary extends CallRealtimeStatistics, UserRealtimeStatistics {
    [key: string]: number | string | undefined; // ← allows dynamic access
}
